// @ts-strict

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// @ts-ignore
import Fingerprint2 from '@fingerprintjs/fingerprintjs';
import { BaseApiResponse, HttpOptions } from '@app/core/models/core-models';
import { environment } from '@env/environment';
import { unescape } from 'lodash';
import { GetUserBasicDataService } from '@services/get-user-basic-data/get-user-basic-data.service';
import { take } from 'rxjs/operators';

export interface ActivityParams {
  canvas: string;
  webgl: string;
  hash: string;
  ua: string;
  lang: string;
  colorDepth: string;
  deviceMemory: string;
  hardwareConcurrency: string;
  screenResolution: string;
  availableScreenResolution: string;
  ratio: string;
  screenResolutionNative: string;
  availableScreenResolutionNative: string;
  timezoneOffset: string;
  timezone: string;
  platform: string;
  hasLiedLanguages: string;
  hasLiedResolution: string;
  hasLiedOs: string;
  hasLiedBrowser: string;
  adBlock: string;
  webglVendorAndRenderer: string;
}

@Injectable({
  providedIn: 'root'
})
export class CollectActivityService {
  public collectedActivityData: string | undefined;

  constructor(private http: HttpClient, private userDataService: GetUserBasicDataService) {}

  public getFingerprint(): void {
    setTimeout(() => {
      Fingerprint2.get((components: { key: string; value: any }[]) => {
        this.collectedActivityData = this.fingerPreparator(components);
      });
    }, 50);
  }

  public getFingerprintNow(): void {
    Fingerprint2.get((components: { key: string; value: any }[]) => {
      this.collectedActivityData = this.fingerPreparator(components);
    });
  }

  public sendFingerprint(): void {
    setTimeout(() => {
      Fingerprint2.get((components: { key: string; value: any }[]) => {
        this.collectedActivityData = this.fingerPreparator(components);
        let activity_params = this.collectedActivityData;

        this.http.post<BaseApiResponse<{ message?: string }>>(environment.apiUrl + '/activity/send_activity_data', { activity_params }).subscribe(
          res => {
            // console.log(res);
          },
          error => console.log(error)
        );
      });
    }, 500);
  }

  checkMeThenSendFingerprint(): void {
    // todo: change this for another endpoint that just returns flag
    this.userDataService
      .getBasicUserInfo()
      .pipe(take(1))
      .subscribe(res => {
        // console.log('check me');
        if (res?.data?.send_activity_data) {
          this.sendFingerprint();
        }
      });
  }

  private static finder(components: { key: string; value: any }[], key: any) {
    for (let i = 0; i < components.length; i++) {
      if (components[i].key === key) {
        return components[i].value;
      }
    }
  }

  private static ratio(): number {
    return window.devicePixelRatio || 1;
  }

  private static joiner(components: { key: string; value: any }[], key: any) {
    let toJoin = CollectActivityService.finder(components, key);
    if (toJoin === undefined) {
      return '';
    } else {
      return toJoin.join('x');
    }
  }

  private fingerPreparator(components: { key: string; value: any }[]) {
    const f_canvas = Fingerprint2.x64hash128(
      components
        .map(function (pair) {
          if (pair.key === 'canvas') {
            return pair.value;
          }
        })
        .join(),
      31
    );

    const f_webgl = Fingerprint2.x64hash128(
      components
        .map(function (pair) {
          if (pair.key === 'webgl') {
            return pair.value;
          }
        })
        .join(),
      31
    );

    const f_hash = Fingerprint2.x64hash128(
      components
        .map(function (pair) {
          if (pair.key === 'canvas' || pair.key === 'webgl' || pair.key === 'timezone' || pair.key === 'deviceMemory' || pair.key === 'hardwareConcurrency') {
            return pair.value;
          }
        })
        .join(),
      31
    );
    let screenResolution = () => {
      const pixelRatio = CollectActivityService.ratio();
      const resolution = [Math.round(window.screen.width * pixelRatio), Math.round(window.screen.height * pixelRatio)];
      resolution.sort().reverse();
      return resolution.join('x');
    };
    let availableScreenResolution = () => {
      const pixelRatio = CollectActivityService.ratio();
      if (window.screen.availWidth && window.screen.availHeight) {
        let available = [Math.round(window.screen.availHeight * pixelRatio), Math.round(window.screen.availWidth * pixelRatio)];
        available.sort().reverse();
        return available.join('x');
      }
      return 'not available';
    };

    let params = JSON.stringify({
      // u_a_h_value: u_a_h_value,
      canvas: f_canvas,
      webgl: f_webgl,
      hash: f_hash,
      ua: CollectActivityService.finder(components, 'userAgent'),
      lang: CollectActivityService.finder(components, 'language'),
      colorDepth: CollectActivityService.finder(components, 'colorDepth'),
      deviceMemory: CollectActivityService.finder(components, 'deviceMemory'),
      hardwareConcurrency: CollectActivityService.finder(components, 'hardwareConcurrency'),
      screenResolution: screenResolution(),
      availableScreenResolution: availableScreenResolution(),
      ratio: CollectActivityService.ratio(),
      screenResolutionNative: CollectActivityService.joiner(components, 'screenResolution'),
      availableScreenResolutionNative: CollectActivityService.joiner(components, 'availableScreenResolution'),
      timezoneOffset: CollectActivityService.finder(components, 'timezoneOffset'),
      timezone: CollectActivityService.finder(components, 'timezone'),
      platform: CollectActivityService.finder(components, 'platform'),
      hasLiedLanguages: CollectActivityService.finder(components, 'hasLiedLanguages')?.toString() ?? 'undefined',
      hasLiedResolution: CollectActivityService.finder(components, 'hasLiedResolution')?.toString() ?? 'undefined',
      hasLiedOs: CollectActivityService.finder(components, 'hasLiedOs')?.toString() ?? 'undefined',
      hasLiedBrowser: CollectActivityService.finder(components, 'hasLiedBrowser')?.toString() ?? 'undefined',
      adBlock: CollectActivityService.finder(components, 'adBlock')?.toString() ?? 'undefined',
      webglVendorAndRenderer: CollectActivityService.finder(components, 'webglVendorAndRenderer')
    });

    return btoa(params);
  }
}
